import {
    GET_SCHEMA_PROFILE_FAILURE,
    GET_SCHEMA_PROFILE_SUCCESS,
    GET_SCHEMA_PROFILE_UNSUPPORTED,
    RESET_SCHEMA_PROFILE,
    SET_ALL_SUGGESTION_STATUSES,
    SET_SUGGESTION_STATUS,
    SUGGESTION_STATUS,
} from "./actions";

const initialState = {
    getSchemaProfileResult: { success: true },
    schemaProfile: null,
    // Keyed by suggestion id. Absent means PENDING, which is treated as
    // rejected when applying: nothing is ever applied implicitly.
    suggestionStatuses: {},
    unsupported: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_SCHEMA_PROFILE_SUCCESS:
            return {
                ...state,
                getSchemaProfileResult: { success: true },
                schemaProfile: action.payload.schemaProfile,
                // Every suggestion starts un-accepted. A user who clicks
                // straight through gets today's unassisted schema.
                suggestionStatuses: {},
                unsupported: null,
            };

        case GET_SCHEMA_PROFILE_FAILURE:
            return {
                ...state,
                getSchemaProfileResult: { success: false, ...action.payload.error },
                schemaProfile: null,
                suggestionStatuses: {},
            };

        case GET_SCHEMA_PROFILE_UNSUPPORTED:
            return {
                ...state,
                // Deliberately success: the wizard continues unassisted rather
                // than showing the user an error they did not cause.
                getSchemaProfileResult: { success: true },
                schemaProfile: null,
                suggestionStatuses: {},
                unsupported: { reason: action.payload.reason, message: action.payload.message },
            };

        case SET_SUGGESTION_STATUS:
            return {
                ...state,
                suggestionStatuses: {
                    ...state.suggestionStatuses,
                    [action.payload.suggestionId]: action.payload.status,
                },
            };

        case SET_ALL_SUGGESTION_STATUSES: {
            if (!state.schemaProfile) return state;
            const { status, fieldName } = action.payload;
            const statuses = { ...state.suggestionStatuses };
            state.schemaProfile.fields.forEach((field) => {
                if (fieldName && field.name !== fieldName) return;
                field.suggestions.forEach((suggestion) => {
                    statuses[suggestion.id] = status;
                });
            });
            return { ...state, suggestionStatuses: statuses };
        }

        case RESET_SCHEMA_PROFILE:
            return { ...initialState };

        default:
            return state;
    }
};

// --- Selectors -----------------------------------------------------------

export const selectAcceptedSuggestionIds = (suggestionStatuses) =>
    Object.keys(suggestionStatuses || {}).filter((id) => suggestionStatuses[id] === SUGGESTION_STATUS.ACCEPTED);

export const selectSuggestionCounts = (schemaProfile, suggestionStatuses) => {
    const counts = { total: 0, accepted: 0, rejected: 0, pending: 0 };
    if (!schemaProfile) return counts;
    schemaProfile.fields.forEach((field) => {
        field.suggestions.forEach((suggestion) => {
            counts.total += 1;
            const status = (suggestionStatuses || {})[suggestion.id] || SUGGESTION_STATUS.PENDING;
            if (status === SUGGESTION_STATUS.ACCEPTED) counts.accepted += 1;
            else if (status === SUGGESTION_STATUS.REJECTED) counts.rejected += 1;
            else counts.pending += 1;
        });
    });
    return counts;
};
